module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sh-ac-839066bb5d29b83abb5e2a82a6a43f26.svg";